export const COOL_FINNISH_TECH_URL_PATHS = {
  en: '/en/resources/jobs-in-finland/cool-finnish-tech-companies-english',
  fi: '/fi/tyoelama/suomalaiset-tech-yritykset-tyokielena-englanti',
  sv: '/sv/arbetsliv/finska-techbolag-engelska-arbetssprak',
} as const;

export type CoolFinnishTechLocale = keyof typeof COOL_FINNISH_TECH_URL_PATHS;
